export default __webpack_public_path__ + "static/media/number4.a799e6de.svg";